import { breakpoints, getAttributeValue, LoopHelper } from '@theme/helpers';
import { HTMLCustomElement } from '@theme/html-custom-element';
import { Splide } from '@theme/splide';
import { AutoScroll } from '@theme/splide-autoscroll';

class MarqueeSlider extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    const defaults = {
      gap: getAttributeValue(this, 'gap', 32),
    };

    new Splide(this.refs.slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      autoWidth: true,
      arrows: false,
      pagination: false,
      gap: defaults.gap,
      autoScroll: {
        speed: getAttributeValue(this, 'auto-scroll-speed', 0.5),
      },
      mediaQuery: 'min',
      breakpoints: {
        [breakpoints.large]: {
          gap: getAttributeValue(this, 'gap-large', defaults.gap),
        },
      },
    }).mount({
      AutoScroll,
      LoopHelper,
    });
  }
}

if (!customElements.get('marquee-slider')) customElements.define('marquee-slider', MarqueeSlider);
